import Alpine from 'alpinejs/dist/module.cjs'
const data = (params = {}) => ({
  checked: [],
  enabledFilter: false,

  get tdColspanCounts() {
    return this.enabledFilter ? this.checkedTds : this.checked.length
  },
  get checkedTds() {
    return this.checked.filter((v) => v).length
  },

  async init() {
    await this.$nextTick()
    this.checked = new Array(
      this.$root.querySelectorAll('tr:first-child > td').length
    ).fill(false)
  },
  ...params,
})

Alpine.data('simulationTable', data)
